import { AxiosResponse } from 'axios';
import { API } from 'config';
import { ADDRESS_BY_POSTAL_CODE_TYPE } from 'models';
import { AppAPIInstance } from 'services';

export const getAddressByPostalCodeApi = async (
  postal_code: string
): Promise<AxiosResponse<{ data: ADDRESS_BY_POSTAL_CODE_TYPE }>> => {
  return await AppAPIInstance.get(API.ONE_MAP.DEFAULT.replace(":postal_code", postal_code),);
};